import { useMemoWithDeps } from '@entegral/helpers.react/hooks/memo-with-deps';
import { composeGroups } from '@entegral/domains.pin-point/logic/compose-groups';

export function usePropertiesGroups(properties, zoom) {
  return useMemoWithDeps(composeGroups, [], [properties, zoom]);
}
